window.setupProductionSliderDemo = function setupProductionSliderDemo(options) {
  const slider = options && options.slider;
  const onValueChange = options && options.onValueChange;
  if (!slider || slider.dataset.productionDemoReady === 'true') return;

  const panel = slider.closest('.production-slider-card') || slider.parentElement;
  const reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const touchViewportQuery = window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse), (max-width: 749px)');
  let userTouched = false;
  let isAnimating = false;
  let hasRunDemo = false;
  let hasScrolled = false;
  let animationFrame = null;

  slider.dataset.productionDemoReady = 'true';

  const setUserTouched = () => {
    userTouched = true;
    if (animationFrame) {
      cancelAnimationFrame(animationFrame);
      animationFrame = null;
    }
    isAnimating = false;
    if (panel) panel.classList.remove('is-demoing');
  };

  slider.addEventListener('pointerdown', setUserTouched);
  slider.addEventListener('keydown', setUserTouched);
  slider.addEventListener('input', (event) => {
    if (event.isTrusted) setUserTouched();
  });

  const dispatchSliderInput = () => {
    if (typeof onValueChange === 'function') {
      onValueChange();
      return;
    }
    slider.dispatchEvent(new Event('input', { bubbles: true }));
  };

  const animateTo = (targetValue, duration) => new Promise((resolve) => {
    const startValue = Number(slider.value);
    const endValue = Number(targetValue);
    const startedAt = performance.now();

    const tick = (now) => {
      if (userTouched) {
        resolve();
        return;
      }

      const elapsed = Math.min((now - startedAt) / duration, 1);
      const eased = elapsed < 0.5
        ? 4 * elapsed * elapsed * elapsed
        : 1 - Math.pow(-2 * elapsed + 2, 3) / 2;

      slider.value = String(startValue + ((endValue - startValue) * eased));
      dispatchSliderInput();

      if (elapsed < 1) {
        animationFrame = requestAnimationFrame(tick);
      } else {
        slider.value = String(endValue);
        dispatchSliderInput();
        resolve();
      }
    };

    animationFrame = requestAnimationFrame(tick);
  });

  const shouldUseScrollTrigger = () => touchViewportQuery && touchViewportQuery.matches;

  const isSeenEnough = () => {
    if (!panel) return false;

    const rect = panel.getBoundingClientRect();
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight;
    const viewportWidth = window.innerWidth || document.documentElement.clientWidth;
    const visibleHeight = Math.min(rect.bottom, viewportHeight) - Math.max(rect.top, 0);
    const visibleWidth = Math.min(rect.right, viewportWidth) - Math.max(rect.left, 0);

    if (visibleHeight <= 0 || visibleWidth <= 0) return false;

    const heightRatio = visibleHeight / Math.max(rect.height, 1);
    const widthRatio = visibleWidth / Math.max(rect.width, 1);
    return heightRatio >= 0.6 && widthRatio >= 0.7;
  };

  const runDemo = async () => {
    if (userTouched || isAnimating || hasRunDemo || reducedMotion) return;
    isAnimating = true;
    hasRunDemo = true;

    const originalStep = slider.getAttribute('step') || '1';
    const originalValue = Number(slider.value);
    const minValue = Number(slider.min || 0);
    const demoTarget = Math.max(minValue, originalValue - 2);

    if (panel) {
      panel.classList.add('is-demoing');
      panel.classList.add('has-demoed');
    }

    slider.step = 'any';
    await animateTo(demoTarget, 1450);
    await new Promise(resolve => setTimeout(resolve, 260));
    await animateTo(originalValue, 2050);
    slider.step = originalStep;
    slider.value = String(originalValue);
    dispatchSliderInput();

    if (panel) panel.classList.remove('is-demoing');
    isAnimating = false;
  };

  if (panel) {
    panel.addEventListener('mouseenter', () => {
      if (!shouldUseScrollTrigger()) runDemo();
    });
  }
  slider.addEventListener('focus', runDemo);

  if (panel && shouldUseScrollTrigger()) {
    let observer = null;

    const cleanupScrollTrigger = () => {
      window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', tryRunFromScroll);
      if (observer) observer.disconnect();
    };

    const tryRunFromScroll = () => {
      if (!hasScrolled || hasRunDemo || userTouched || !isSeenEnough()) return;
      cleanupScrollTrigger();
      runDemo();
    };

    const onScroll = () => {
      hasScrolled = true;
      tryRunFromScroll();
    };

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', tryRunFromScroll, { passive: true });

    if ('IntersectionObserver' in window) {
      observer = new IntersectionObserver(() => {
        tryRunFromScroll();
      }, { threshold: [0.6, 0.75, 0.9] });
      observer.observe(panel);
    }
  }
};
